export default function PHP_is_writeable() {
  return (
    <div>
      <h1>PHP_is_writeable</h1>
    </div>
  );
}
